import {ErrorModel} from '../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../root';
const FUNCTION_CODE = 'DOWNLOAD_REFERENCE_BY_ID';

export async function downloadReferenceById(
    userToken: string,
    id:number
) {
    console.log('URL', URL);
    console.log('userToken', userToken);
    try {
        const response = await axios.get(
            `${URL}/references/${id}/download/`,
            {
                responseType: 'blob',
                headers: {
                    Accept: 'application/json',
                    Authorization: `Token ${userToken}`
                }
            },
        );

        return response.data;
    }

    catch (error: any) {
        console.log(error);
        const errorMessage = () => {
            if (error.response.data.detail) {
                return error.response.data.detail;
            }
            else {
                return 'Une erreur est survenue lors du téléchargement d\'une réference';
            }
        };
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: errorMessage(),
            error: error
        });
    }
}
